import React, { useState } from "react";
import { Button, Dialog, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PasswordInput from "../TextBox/PasswordInput";
import Checkbox from "../Checkbox/Checkbox";
import useFirebase from "../../hooks/useFirebase";

const LoginPopup = ({
  onLogin,
  isOpen,
  onClose,
  onForgotPasswordClick,
  onRegisterNowClick,
}) => {
  const { googleSignIn, facebookSignIn, emailSignIn } = useFirebase();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormData({ ...formData, [name]: newValue });
  };

  const handleLogin = () => {
    // onLogin(formData.email, formData.password);
    emailSignIn(formData.email, formData.password) // login via firebase
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const handleGoogleLogin = () => {
    googleSignIn();
  };

  const handleFacebookLogin = () => {
    console.log("Logging in with Facebook...");
    facebookSignIn();
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="LoginRegisterPopupContainer">
      <Dialog
        open={isOpen}
        onClose={onClose}
        className="loginregister-popup-section"
      >
        <DialogContent>
          <div className="two-columns-grid login_web_view">
            <div className="first-coloumn">
              <div className="first-coloumn-title">Login to KPJ </div>
              <div className="social-media-group">
                <div className="signin-google" onClick={handleGoogleLogin}>
                  <img src="/img/icon/icons8-google-48.png" />
                  Sign in with Google{" "}
                </div>
                <div className="signin-facebook" onClick={handleFacebookLogin} style={{ display: "none" }}>
                  <img src="/img/icon/icons8-facebook-48.png" />
                  Sign in with Facebook
                </div>
              </div>

              <div className="signin-or">- OR -</div>

              <form>
                <div className="login-emailpassword-group">
                  <div className="textbox-email">
                    <div>
                      <label htmlFor="email">Email:</label>
                    </div>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      placeholder="Type your email"
                      onChange={handleChange}
                      style={{ width: "-webkit-fill-available" }}
                    />
                  </div>
                  <div className="textbox-password">
                    <div>
                      <label htmlFor="password">Password:</label>
                    </div>
                    <PasswordInput
                      placeholder="Enter Password"
                      value={formData.password}
                      onChange={handleChange}
                      onKeyPress={handleKeyPress}
                    />
                  </div>
                </div>

                <div className="remember-me-group">
                  <div className="remember-me">
                    <Checkbox
                      checked={formData.rememberMe}
                      onChange={handleChange}
                      label="Remember me"
                      name="rememberMe"
                    />
                  </div>
                  <div className="forgot-password">
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={onForgotPasswordClick}
                    >
                      Forgot Password?
                    </span>
                  </div>
                </div>
                <div className="login-button">
                  <Button onClick={handleLogin} color="primary">
                    Login
                  </Button>
                </div>
              </form>

              <div className="login-des">
                Still don't have an account?
                <span
                  style={{ fontWeight: "600", cursor: "pointer" }}
                  onClick={onRegisterNowClick}
                >
                  Register Now
                </span>
              </div>
            </div>

            <div className="second-coloumn">
              <img
                src="/img/homepage/login-thumbnail.png"
                alt=""
                style={{
                  width: "-webkit-fill-available",
                  height: "-webkit-fill-available",
                }}
              />
              <IconButton
                aria-label="close"
                onClick={onClose}
                style={{ position: "absolute", top: "8px", right: "8px" }}
              >
                <CloseIcon />
              </IconButton>{" "}
            </div>
          </div>

          <div className="login_mob_view">
            <div
              style={{
                backgroundImage: 'url("/img/bg/login-banner-mobile.png")',
                backgroundSize: "100%",
                height: "245px",
                backgroundRepeat: "no-repeat",
                display: "flex",
                alignItems: "end",
                justifyContent: "flex-end",
                position: "relative",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  fontSize: "25px",
                  fontWeight: "400",
                  color: "white",
                  padding: "28px",
                }}
              >
                <span
                  style={{
                    fontSize: "25px",
                    fontWeight: "700",
                    color: "white",
                    lineHeight: "30.52px",
                  }}
                >
                  Extraordinary Care
                  <br />
                </span>
                Is Right Here
              </p>
              <IconButton
                aria-label="close"
                onClick={onClose}
                style={{ position: "absolute", top: "8px", right: "8px" }}
              >
                <CloseIcon style={{ color: "white" }} />
              </IconButton>{" "}
            </div>
            <div
              className="container"
              style={{ padding: "24px", textAlign: "center" }}
            >
              <p
                style={{
                  fontWeight: "700",
                  fontSize: "25px",
                  color: "black",
                  marginBottom: "20px",
                }}
              >
                Login to KPJ
              </p>
              <div
                onClick={handleGoogleLogin}
                style={{
                  border: "0.76px solid #969696",
                  borderRadius: "7.6px",
                  marginBottom: "5px",
                }}
              >
                <img src="/img/icon/icons8-google-48.png" />
                Sign in with Google{" "}
              </div>
              <div
                onClick={handleFacebookLogin}
                style={{
                  border: "0.76px solid #969696",
                  borderRadius: "7.6px",
                  display: "none"
                }}
              >
                <img src="/img/icon/icons8-facebook-48.png" />
                Sign in with Facebook
              </div>
              <div style={{ margin: "16px 0" }}>- OR -</div>
              <form>
                <div className="login-emailpassword-group">
                  <div
                    style={{
                      border: "none",
                      background: "white",
                      width: "100%",
                      padding: "8px",
                      borderRadius: "10px",
                      textAlign: "left",
                      marginBottom: "8px",
                    }}
                  >
                    <label htmlFor="email" style={{ color: "black" }}>
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      placeholder="Type your email"
                      onChange={handleChange}
                      style={{
                        width: "-webkit-fill-available",
                        border: "none",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      border: "none",
                      background: "white",
                      width: "100%",
                      padding: "8px",
                      borderRadius: "10px",
                      textAlign: "left",
                      position: "relative",
                    }}
                  >
                    <label htmlFor="password" style={{ color: "black" }}>
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder={"Enter Password"}
                      style={{
                        width: "-webkit-fill-available",
                        border: "none",
                      }}
                      onKeyPress={handleKeyPress}
                    />
                    <div
                      onClick={togglePasswordVisibility}
                      style={{
                        position: "absolute",
                        right: "16px",
                        bottom: "16px",
                      }}
                    >
                      {showPassword ? (
                        <i className="fas fa-eye"></i>
                      ) : (
                        <i className="fas fa-eye-slash"></i>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "12px",
                    marginBottom: "40px",
                  }}
                >
                  <div className="remember-me">
                    <Checkbox
                      checked={formData.rememberMe}
                      onChange={handleChange}
                      label="Remember me"
                      name="rememberMe"
                    />
                  </div>
                  <div className="forgot-password">
                    <span
                      style={{
                        cursor: "pointer",
                        color: "#967F65",
                        textDecorationLine: "underline",
                      }}
                      onClick={onForgotPasswordClick}
                    >
                      Forgot Password?
                    </span>
                  </div>
                </div>
                <div className="login-button">
                  <Button
                    onClick={handleLogin}
                    style={{
                      background: "#967F65",
                      color: "white",
                      width: "100%",
                      borderRadius: "99px",
                      textTransform: "capitalize",
                      fontSize: "17px",
                      fontWeight: "700",
                    }}
                  >
                    Login
                  </Button>
                </div>
              </form>
              <div style={{ marginTop: "12px" }}>
                <p
                  style={{
                    marginBottom: "0",
                    fontSize: "13px",
                    lineHeight: "15.51px",
                    color: "#606060",
                  }}
                >
                  Still don't have an account?
                </p>

                <p
                  style={{
                    fontWeight: "600",
                    cursor: "pointer",
                    color: "#967F65",
                    fontSize: "13px",
                    lineHeight: "15.87px",
                  }}
                  onClick={onRegisterNowClick}
                >
                  Register Now
                </p>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default LoginPopup;
